<template>
  <div class="d-inline-flex align-items-center">
    <b-badge
      v-if="type === 'environment'"
      :variant="environmentVariant"
      class="mr-1"
    >
      {{ environmentText }}
    </b-badge>

    <b-badge
      v-if="type === 'status'"
      :variant="statusVariant"
    >
      {{ statusText }}
    </b-badge>
  </div>
</template>

<script>
export default {
  name: 'ApiKeyBadges',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['environment', 'status'].includes(value)
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    environmentVariant() {
      return this.value === 'sandbox' ? 'warning' : 'success';
    },
    environmentText() {
      return this.value === 'sandbox' ? 'Sandbox' : 'Live';
    },
    statusVariant() {
      const variants = {
        active: 'success',
        inactive: 'secondary',
        revoked: 'danger'
      };
      return variants[this.value] || 'secondary';
    },
    statusText() {
      const texts = {
        active: 'Active',
        inactive: 'Inactive',
        revoked: 'Revoked'
      };
      return texts[this.value] || this.value;
    }
  }
};
</script>

<style scoped>
.b-badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}
</style>
